/* Cart recommendations use the existing origin-checked Accounts ranking/session feeds. */
(() => {
  const key = id => String(id || '').split('/').pop();
  function choose(candidates, ranks, cartIds = [], ownedIds = []) {
    const excluded = new Set([...cartIds, ...ownedIds].map(key)), seen = new Set();
    return candidates.filter(p => {
      if (excluded.has(key(p.id)) || seen.has(key(p.id)) || !ranks.has(p.handle)) return false;
      seen.add(key(p.id)); return true;
    }).sort((a,b) => ranks.get(a.handle) - ranks.get(b.handle)).slice(0,2);
  }
  if (typeof module === 'object' && module.exports) module.exports = {choose};
  if (typeof document === 'undefined') return;
  let ranks = new Map(), account = null, proxy = null, proxyRequest, cartPending = false, cartVersion = 0;
  const redraw = () => document.querySelectorAll('sofly-cart-suggestions').forEach(el => el.refresh());
  // Dawn updates drawer sections and the full cart separately. Reconcile both
  // recommendation lists after adds, quantity changes and removals.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    const version = ++cartVersion; cartPending = true; redraw();
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (version !== cartVersion || !Array.isArray(cart.items)) return;
      const ids = JSON.stringify(cart.items.map(item => item.product_id)); cartPending = false;
      document.querySelectorAll('sofly-cart-suggestions').forEach(el => { el.dataset.cartProducts = ids; el.refresh(); });
    } catch { /* Keep suggestions hidden until the cart can be verified. */ }
  });
  document.addEventListener('sofly:store-ranking', event => {
    ranks = new Map((Array.isArray(event.detail) ? event.detail : []).filter(p => p && typeof p.handle === 'string' && Number.isInteger(p.rank) && p.rank > 0).map(p => [p.handle,p.rank]));
    redraw();
  });
  document.addEventListener('sofly:account-state', event => { account = event.detail; redraw(); });
  customElements.define('sofly-cart-suggestions', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.shopifyCustomer === 'true' && !proxyRequest) {
        proxyRequest = fetch('/apps/sofly-notifications/ownership', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
          .then(r => { if (!r.ok) throw Error('Ownership unavailable'); return r.json(); })
          .then(data => { if (data.signedIn && Array.isArray(data.ownedProductIds)) proxy = data.ownedProductIds; redraw(); })
          .catch(() => { /* Do not suggest potentially owned products while ownership is unverified. */ });
      }
      this.refresh();
    }
    refresh() {
      this.hidden = true;
      const list = this.querySelector('[data-sf-cart-suggestion-list]');
      if (!list) return;
      list.replaceChildren();
      if (cartPending || !account || typeof account.authenticated !== 'boolean' || !ranks.size) return;
      if (!account.authenticated && this.dataset.shopifyCustomer === 'true' && !proxy) return;
      const owned = account.authenticated ? [...(account.ownedProductIds || []), ...(account.excludedProductIds || [])] : this.dataset.shopifyCustomer === 'true' ? proxy : [];
      let cartIds;
      try { cartIds = JSON.parse(this.dataset.cartProducts); if (!Array.isArray(cartIds) || !cartIds.length) return; } catch { return; }
      const candidates = [...this.querySelectorAll('template[data-sf-cart-candidate]')].map(template => ({id:template.dataset.productId,handle:template.dataset.productHandle,template}));
      const selected = choose(candidates, ranks, cartIds, owned);
      for (const p of selected) list.append(p.template.content.cloneNode(true));
      this.hidden = !selected.length;
    }
  });
})();
